(function () {
  class OversizedSymbolAnimator extends PIXI.Container {
    constructor() {
      super();
      this.visible = false;
      this._trackInfo = undefined;
      this._bgMovie = undefined;
      Reflex.registerEventHandler(
        "orientationChange",
        this.onOrientationChange.bind(this)
      );
    }

    play(trackInfo, loop, onCellAnimFinishedCb) {
      this._trackInfo = trackInfo;
      this.initialiseSymbolMovie(trackInfo.getPosition());
      trackInfo.showSymbol(false);
    }

    initialiseSymbolMovie(symPos) {
      this.visible = true;
      this._movie.gotoAndStop(0);
      if (this._bgMovie !== undefined) {
        this._bgMovie.gotoAndStop(0);
      }
      if (this._fsmovie !== undefined) {
        this._fsmovie.gotoAndStop(0);
      }
      this.position.set(
        symPos.x + this._positionOffset.x,
        symPos.y + this._positionOffset.y
      );
    }

    getTrackInfo() {
      return this._trackInfo;
    }

    finalise() {
      this.visible = false;
      this._trackInfo.showSymbol(true);
      this._trackInfo = undefined;
    }

    untrack() {
      if (this._trackInfo) {
        this._trackInfo.untrack();
      }
    }

    skip() {
      this.untrack();
    }

    onOrientationChange() {
      if (this._trackInfo !== undefined) {
        let symPos = this._trackInfo.getPosition();
        this.position.set(
          symPos.x + this._positionOffset.x,
          symPos.y + this._positionOffset.y
        );
      }
    }
  }

  let create = function () {
    return new OversizedSymbolAnimator();
  };

  let initialise = function (json, instance) {
    if (json.playData.includeBgAnim) {
      instance._bgMovie = resourceManager.createObject(
        "movie",
        "bgAnim",
        instance.name,
        {
          definition: "Symbol_BgWin",
        }
      );
      instance._bgMovie.loop = 0;
      instance._bgMovie.gotoAndStop();
      instance._bgMovie.anchor.set(0.5);
    }
    instance._movie = resourceManager.createObject(
      "movie",
      json.playData.definition,
      instance.name,
      {
        definition: json.playData.definition,
      }
    );
    instance._movie.loop = false;
    instance._movie.gotoAndStop(0);
    instance._movie.anchor.set(0.5);

    if (json.playData.lowWinDefinition !== undefined) {
      instance._lowWinmovie = resourceManager.createObject(
        "movie",
        json.playData.lowWinDefinition,
        instance.name,
        {
          definition: json.playData.lowWinDefinition,
        }
      );
      instance._lowWinmovie.loop = false;
      instance._lowWinmovie.gotoAndStop(0);
      instance._lowWinmovie.anchor.set(0.5);
      instance._lowWinmovie.visible = false;
    }

    instance._positionOffset = { x: 0, y: 0 };
    if (json.playData.posOffset) {
      instance._positionOffset = json.playData.posOffset;
    }
    if (json.playData.alwaysPlay) {
      instance._alwaysPlay = json.playData.alwaysPlay;
    }
  };

  let getRequiredFiles = function () {
    return [];
  };

  resourceManager.registerObjectType(
    "oversizedSymbolAnimator",
    create,
    initialise,
    getRequiredFiles
  );
})();
